<div class="groups">
    <div class="lg:w-full mx-auto py-3 px-6">
        <div class="filters w-full flex flex-wrap justify-content-around gap-2">
            <div class="filter-row flex align-items-center ">
                <span class="mr-3">SJC name: </span>
                <div class="flex flex-column gap-2">
                    <p-iconField iconPosition="left">
                        <p-inputIcon styleClass="pi pi-search"/>
                        <input type="text" pInputText placeholder="Search by sjc name" [(ngModel)]="groupName"/>
                    </p-iconField>
                </div>
            </div>
            <div class="filter-row">
                <span class="mr-3">Show approved: </span>
                <p-dropdown
                        [options]="defaultOptions"
                        [(ngModel)]="selectedShowApprove"
                        placeholder="Select"/>
            </div>
            <div class="filter-row">
                <span class="mr-3">Max images: </span>
                <p-dropdown
                        [options]="maxImagesOptions"
                        [(ngModel)]="selectedMaxImages"
                        placeholder="Select"/>
            </div>
        </div>
        <div class="w-2 mx-auto mt-3">
            <p-button label="Filter" styleClass="w-full" size="small" (onClick)="loadImages({})"/>
        </div>
    </div>
    <main>
        <p-table
                [value]="images"
                [paginator]="true"
                [lazy]="true"
                [rows]="perPage"
                [loading]="imagesLoading"
                [totalRecords]="totalRecords"
                [tableStyle]="{ 'min-width': '50rem' }"
                (onLazyLoad)="loadImages($event)"
                [rowsPerPageOptions]="[10, 25, 50]"
                styleClass="p-datatable-striped">
            <ng-template pTemplate="header">
                <tr>
                    <th>Group</th>
                    <th>Images</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-group>
                <tr>
                    <td>
                        @for (name of group[0][0].split('//'); track name) {
                            <p class="first-td">{{ name }}</p>
                        }
                    </td>
                    <td>
                        <div class="images">
                            @for (image of group[1]; track image.image_url) {
                                <p-card class="image" header="{{ image.topic_name }}"
                                        subheader="{{ image.action_name }}"
                                        [style]="{ width: '360px' }">
                                    <ng-template pTemplate="header">
                                        <p-image
                                                src="https://insp-img.autotechiq.com/webp/{{ image.webp }}"
                                                alt="Image"
                                                [preview]="true"/>
                                    </ng-template>
                                    <p-divider></p-divider>
                                    <p class="notes">
                                        <b>Notes:</b><br><i>{{ image.custom_caption || image.caption }}</i></p>

                                    <ng-template pTemplate="footer">
                                        <div class="approve mb-2">
                                            <p class="flex  align-items-center justify-content-between">
                                                <span><strong>Approved: </strong></span>
                                                <p-checkbox
                                                        [(ngModel)]="image.approved"
                                                        [binary]="true"
                                                        inputId="binary"
                                                        class="checkbox-approve"
                                                        (onChange)="this.onChangeCheckbox(image, $event)"
                                                />
                                            </p>
                                            <p class="mt-2">
                                                <small>
                                                    <strong>Arr: </strong> {{ image.score | round: 2 }}
                                                </small>
                                            </p>
                                        </div>
                                    </ng-template>
                                </p-card>
                            }
                            @if (group[1].length === 0) {
                                <span>No image candidates</span>
                            }
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </main>
</div>
